import React from "react";
import { Typography, Box, Button, Paper } from "@mui/material";
import { MatchingRound } from "../types";
import { StepContainer } from "./StepContainer";

interface SelectMatchingRoundStepProps {
  matchingRounds: MatchingRound[];
  selectedMatchingRound: number | null;
  handleMatchingRoundChange: (event: any) => void;
}

export const SelectMatchingRoundStep: React.FC<SelectMatchingRoundStepProps> = ({
  matchingRounds,
  selectedMatchingRound: _selectedMatchingRound,
  handleMatchingRoundChange
}) => {
  const handleSelectRound = (roundId: number) => {
    // Create a synthetic event object that mimics the structure expected by handleMatchingRoundChange
    const event = {
      target: {
        value: roundId
      }
    };
    handleMatchingRoundChange(event);
  };

  const leftPanel = (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
      {/* Only show matching rounds that are eligible for export: CLOSED or ACTIVE (post matching) */}
      {matchingRounds.filter(round => round.status === "CLOSED" || round.status === "ACTIVE").map((round) => (
        <Paper
          key={round.id}
          elevation={0}
          sx={{
            p: 3,
            borderRadius: '12px',
            border: '1px solid #e8e8e8',
            display: 'flex',
            flexDirection: 'column',
            minWidth: '280px',
            maxWidth: '340px',
            gap: 2
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: '16px',
              fontWeight: 600,
              color: '#1e3a5f',
              lineHeight: 1.4
            }}
          >
            {round.name}
          </Typography>

          <Button
            variant="contained"
            onClick={() => handleSelectRound(round.id)}
            sx={{
              bgcolor: '#2167e2',
              '&:hover': { bgcolor: '#1a52b3' },
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '14px',
              padding: '10px 24px',
              borderRadius: '8px',
              boxShadow: 'none',
              alignSelf: 'flex-start'
            }}
          >
            Select
          </Button>
        </Paper>
      ))}
    </Box>
  );

  const rightPanel = null;

  return (
    <StepContainer leftPanel={leftPanel} rightPanel={rightPanel} />
  );
};
